import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const phoneNumber = '14102455584'; // Country code + phone number
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: 'fixed',
        bottom: '2rem',
        right: '2rem',
        width: '60px',
        height: '60px',
        background: '#33cccc',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(51, 204, 204, 0.4)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        transform: isHovered ? 'scale(1.1)' : 'scale(1)',
        zIndex: 1000,
        textDecoration: 'none'
      }}
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={28} color="white" />
      
      {/* Pulse animation ring */}
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          border: '2px solid #33cccc',
          animation: 'pulse 2s infinite',
          opacity: 0.5
        }}
      />

      <style>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 0.5;
          }
          50% {
            transform: scale(1.2);
            opacity: 0;
          }
          100% {
            transform: scale(1);
            opacity: 0;
          }
        }

        @media (max-width: 767px) {
          /* Adjust position for mobile */
          a[aria-label="Contact us on WhatsApp"] {
            bottom: 1rem !important;
            right: 1rem !important;
            width: 56px !important;
            height: 56px !important;
          }
        }
      `}</style>
    </a>
  );
};

export default WhatsAppButton;
